module.exports = __webpack_public_path__ + "img/about_title2.8d94d686.png";